import  * as React from "react";
import { observer } from "mobx-react";
import {IOptimizerDataViewControlParams} from "./IOptimizerDataViewControlParams";
import { OptimizerTiles } from "./OptimizerTiles/OptimizerTiles";
import { OptimizerBars } from "./OptimizerBars/OptimizerBars";
import { OptimizerSingleBar } from "./OptimizerSingleBar/OptimizerSingleBar";

@observer
export class OptimizerDataViewControl extends React.Component<IOptimizerDataViewControlParams>{
    constructor(props: IOptimizerDataViewControlParams) {
        super(props, undefined);
    }

    render() {
        return <div className="OptimizerDataViewControl">
                   <div className="OptimizerViewContainer row">
                       <OptimizerTiles optimizerHighlights={this.props.optimizerHighlights} />

                       <OptimizerBars clubType={this.props.clubType}>
                           {this.props.optimizationBars.map((bar, i) => {
                               return <OptimizerSingleBar
                                          title={bar.parameterName}
                                          value={bar.values.value}
                                          min={bar.values.lower}
                                          max={bar.values.upper}
                                          key={bar.parameterName}
                                          unit={bar.unit} />
                           })}
                       </OptimizerBars>
                   </div>
               </div>;
    }
}
